import { Sv } from './Sv';

class TeacherCertificate extends Sv {
    constructor() {
        super();
        this.baseUrl += '/teacherCertificate';
    }

    selectTeacherCertificateListByTrainingPlanProgram({ teacherId } = {}) {
        return super.get('/selectTeacherCertificateListByTrainingPlanProgram', {
            teacherId,
        });
    }
}
export default new TeacherCertificate();
export { TeacherCertificate };
